export default {
  errors: [],
  all_errors: {
    byID: {},
    allIDs: [],
  },
  refreshKey: 0,
  menus: [],
  badges: {},
  highlights: {},
  console: { display: false },
  apis: [],
  user: {
    userID: '',
    isPrimaryUser: false,
    timeJoinded: 0,
    emails: [],
    roles: [],
  },
};
